export const LOCAL_STORAGE_FILTER_KEY = 'pj:filterExpanded';
